import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { memo, useCallback, useEffect, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { AccordionPanel } from "./Accordion/AccordionPanel";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { useCompanyDetailVM } from "presentation/hook/Company/useCompanyDetailVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import _ from "lodash";
import { useMessageBarVM } from "presentation/hook/useMessageBar";


const CompanyBatchUpdatePanel = () => {
    const [companyDtlState] = useCompanyDetailTracked();
    const companyFspVM = useCompanyFspVM();
    const companyDtlVM = useCompanyDetailVM();
    const [isLoading, setIsLoading] = useState(false);
    const { isAdd, isEditable } = companyDtlState.viewState;
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const messageBarVM = useMessageBarVM();
    const [initialScreen, setInitialScreen] = useState<boolean>(true);

    useEffect(() => {
        if (!initialScreen) return;

        if (_.isEmpty(companyDtlState.dynamicOptions.fspCountingFromDropdownOptions)) {
            setIsLoading(true);
            Promise.allSettled([
                companyFspVM.loadDropdownOption(operatingUnit, companyDtlState),
            ]).then(data => {
                companyFspVM.onInitBulkEdiPanel(operatingUnit);
                setIsLoading(false);
                setInitialScreen(false);
            }).catch(error => {
                setIsLoading(false);
                setInitialScreen(false);
            });
        } else {
            companyFspVM.onInitBulkEdiPanel(operatingUnit);
        }
    }, [companyDtlState, companyFspVM, initialScreen, operatingUnit]);

    const closeSlider = useCallback(() => {
        companyDtlVM.onCancel();
    }, [companyDtlVM]);

    const saveButtonClicked = async () => {
        setIsLoading(true);
        await companyFspVM.saveBulkEdit(companyDtlState, operatingUnit).then((data) => {
            if (data && data["fspBulkEditFailed"]) {
                setIsLoading(false);
                messageBarVM.showError(data["fspBulkEditFailed"]?.toString());
                return;
            }

            companyDtlState.companyId && companyFspVM.initialFspTableData(companyDtlState.companyId).then(() => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
            });
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Save Data Failed.');
        });
    }

    return (
        <div className='side-form-content-wrapper'>
            <div className={'im-flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {ChargeDetailConstant.Charge.BULK_EDIT}
                        </SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>
            {/* Stack Form Start */}
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '72vh', maxHeight: '72vh', overflow: 'auto', width: "41vw" }}>
                <div className="im-flex-row">
                    <div className={'flex-row-item flex-row-item-full-width'}>
                        <AccordionPanel />
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={(!isAdd && !isEditable) ? 'Close' : 'Cancel'} size={'Small'} theme={'Secondary'} onClick={closeSlider} />
                {(isAdd || isEditable) && <HPHButton label={isAdd ? 'Add' : isEditable ? 'Update' : 'Save'} size={'Small'} theme={'Primary'} onClick={saveButtonClicked} />}
            </SidebarActionBar>
            {companyDtlState.forceRefresh && <></>}
        </div>
    );
}

export default memo(CompanyBatchUpdatePanel);